const STORAGE_KEY = 'speak.passwordRecovery';

let recovery = false;
const listeners = new Set<() => void>();

export function isRecoveryLocation(search: string, hash: string): boolean {
  const searchParams = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const hashParams = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  return searchParams.get('type') === 'recovery' || hashParams.get('type') === 'recovery';
}

function persist(next: boolean) {
  try {
    if (next) sessionStorage.setItem(STORAGE_KEY, '1');
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // sessionStorage can throw in private-mode or test sandboxes.
  }
}

function readStored(): boolean {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function getPasswordRecovery(): boolean {
  return recovery;
}

export function setPasswordRecovery(next: boolean): void {
  recovery = next;
  persist(next);
  listeners.forEach((listener) => listener());
}

export function subscribePasswordRecovery(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Read the recovery marker before the Supabase client strips the URL hash. */
export function capturePasswordRecoveryFromUrl(): void {
  if (typeof window === 'undefined') return;
  if (isRecoveryLocation(window.location.search, window.location.hash) || readStored()) {
    setPasswordRecovery(true);
  }
}

export function resetPasswordRecoveryForTests(): void {
  recovery = false;
  listeners.clear();
  persist(false);
}

capturePasswordRecoveryFromUrl();
